import { call, put, all, fork, takeEvery } from 'redux-saga/effects';
import { CREATE_GRUPO_CONTROLE_INIT, DELETE_GRUPO_CONTROLE_INIT, LIST_GRUPO_CONTROLE_INIT, UPDATE_GRUPO_CONTROLE_INIT } from '../actionTypes';
import { listGrupoControleSuccess, errorGrupoControleMsg, createGrupoControleSuccess, updateGrupoControleSuccess, deleteGrupoControleSuccess } from './actions';
import { atualizaGrupoControle, criarGrupoControle, deletarGrupoControle, obtemGruposControle } from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';
import { FarmaFuncaoError } from 'src/integracoes/modelos/erros';
import { IEmpresaGrupoControle } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';

interface FetchListGrupoControleResult {
  isError: boolean;
  gruposControle: IEmpresaGrupoControle[] | null;
  msg: string | null;
}

// ------------  LISTA GRUPOS DE CONTROLE --------------------

const fetchGruposControle = async (empId: string) => {
  try {
    const { status, dados, mensagem } = await obtemGruposControle(empId);
    if (status) {
      return {
        isError: false,
        gruposControle: dados,
        msg: mensagem
      };
    }
    return {
      isError: true,
      gruposControle: null,
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaFuncaoError(error);
  }
};

export function* parseListaGruposControle({ payload }: { payload: any, type: any }) {
  const { empId } = payload;

  try {
    const grupoControleData: FetchListGrupoControleResult = yield call(fetchGruposControle, empId);
    if (!grupoControleData.isError) {
      yield put(listGrupoControleSuccess(grupoControleData));
    } else {
      yield put(errorGrupoControleMsg(grupoControleData.msg));
    }
  } catch (error: any) {
    yield put(errorGrupoControleMsg({ msg: error.mensagem }));
  }
}

export function* watchListaGruposControle() {
  yield takeEvery(LIST_GRUPO_CONTROLE_INIT, parseListaGruposControle);
}

// ----------------------- CRIA GRUPO CONTROLE --------------------//

const fetchcriaGrupoControle = async (empId: string, grupoControle: IEmpresaGrupoControle) => {
  try {
    const { status, mensagem } = await criarGrupoControle(empId, grupoControle);
    if (status) {
      return {
        isError: false,
        msg: mensagem
      };
    }
    return {
      isError: true,
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaFuncaoError(error);
  }
};

export function* parseCriaGrupoControle({ payload }: { payload: any, type: any }) {
  const { empId, grupoControle } = payload;
  try {
    const grupoControleData: FetchListGrupoControleResult = yield call(fetchcriaGrupoControle, empId, grupoControle);
    if (!grupoControleData.isError) {
      yield put(createGrupoControleSuccess({ isCreated: true, msg: grupoControleData.msg }));
    } else {
      yield put(errorGrupoControleMsg({ msg: grupoControleData.msg }));
    }
  } catch (error: any) {
    yield put(errorGrupoControleMsg({ msg: error.mensagem }));
  }
}

export function* watchCriaGrupoControle() {
  yield takeEvery(CREATE_GRUPO_CONTROLE_INIT, parseCriaGrupoControle);
}


// ----------------------- ATUALIZA GRUPO CONTROLE --------------------//

const fetchatualizaGrupoControle = async (empId: string, grupoControle: IEmpresaGrupoControle) => {
  try {
    const { status, mensagem } = await atualizaGrupoControle(empId, grupoControle);
    if (status) {
      return {
        isError: false,
        msg: mensagem
      };
    }
    return {
      isError: true,
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaFuncaoError(error);
  }
};

export function* parseAtualizaGrupoControle({ payload }: { payload: any, type: any }) {
  const { empId, grupoControle } = payload;

  try {
    const grupoControleData: FetchListGrupoControleResult = yield call(fetchatualizaGrupoControle, empId, grupoControle);
    if (!grupoControleData.isError) {
      yield put(updateGrupoControleSuccess({ isUpdated: true, msg: grupoControleData.msg }));
    } else {
      yield put(errorGrupoControleMsg({ msg: grupoControleData.msg }));
    }
  } catch (error: any) {
    yield put(errorGrupoControleMsg({ msg: error.mensagem }));
  }
}

export function* watchAtualizaGrupoControle() {
  yield takeEvery(UPDATE_GRUPO_CONTROLE_INIT, parseAtualizaGrupoControle);
}

// ----------------------- REMOVE GRUPO CONTROLE --------------------//

const fetchRemoveGrupoControle = async (empId: string, grupoControleId: string) => {
  try {
    const { status, mensagem } = await deletarGrupoControle(empId, grupoControleId);
    if (status) {
      return {
        isError: false,
        msg: mensagem
      };
    }
    return {
      isError: true,
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaFuncaoError(error);
  }
};

export function* parseRemoveGrupoControle({ payload }: { payload: any, type: any }) {
  const { empId, grupoControleId } = payload;

  try {
    const grupoControleData: FetchListGrupoControleResult = yield call(fetchRemoveGrupoControle, empId, grupoControleId);
    if (!grupoControleData.isError) {
      yield put(deleteGrupoControleSuccess({ isDeleted: true, msg: grupoControleData.msg }));
    } else {
      yield put(errorGrupoControleMsg({ msg: grupoControleData.msg }));
    }
  } catch (error: any) {
    yield put(errorGrupoControleMsg({ msg: error.mensagem }));
  }
}

export function* watchRemoveGrupoControle() {
  yield takeEvery(DELETE_GRUPO_CONTROLE_INIT, parseRemoveGrupoControle);
}

export default function* rootSaga() {
  yield all([
    fork(watchListaGruposControle),
    fork(watchCriaGrupoControle),
    fork(watchAtualizaGrupoControle),
    fork(watchRemoveGrupoControle)
  ]);
}
